export default __webpack_public_path__ + "static/media/home.6a44296d.svg";